import PropTypes from 'prop-types';

import Container from './styled/MiniLoading';

const MiniLoading = ({ fill = 'grey', size = 'large' }) => (
  <Container className="loading-ring" fill={fill} size={size}>
    <div />
    <div />
    <div />
    <div />
  </Container>
);

MiniLoading.propTypes = {
  /**
   * Fill Color to the Loading component
   */
  fill: PropTypes.string,
  size: PropTypes.string,
};

export default MiniLoading;
